/**
 * Os blocos de gráfico do dashboard, agora compartilhados.
 *
 * `Panel`, `MetricCard`, `EmptyState`, `LineChart` e `RankedBars`
 * nasceram dentro de `GlobalDashboardPage.tsx` e saíram de lá em
 * 2026-09-11 porque a tela de consumo de IA precisava dos mesmos cinco
 * blocos — e copiá-los seria a quinta cópia da classe de bug que o
 * `Pager` fechou (quatro rodapés, quatro aritméticas). As classes CSS
 * continuam `dashboard-*` de propósito: o estilo mora em
 * `styles/dashboard.css`, é global, e renomear mudaria a tela sem
 * mudar nada de útil. `BreakdownTable` e `SentimentDonut` ficaram lá:
 * os dois leem `DashboardMetric` (polaridade, CENA, valoração) e não
 * têm segundo consumidor.
 *
 * Os dois gráficos falam uma forma NEUTRA (`{ key, label, value }`),
 * não os tipos do dashboard — quem escolhe QUAL número vira `value`
 * (menções? alcance? custo?) é a tela, no adaptador dela. A prova de
 * que a extração não mudou um byte do HTML está em `charts.test.tsx`.
 */

import type { ReactNode } from "react";

import { ChartDownload } from "./chart-kit";

export function Panel({ title, subtitle, children, className = "", action, downloadable = false }: {
  title: string; subtitle?: string; children: ReactNode; className?: string; action?: ReactNode;
  /** Botões de PNG/SVG do quadro inteiro (sem os controles e sem fundo) —
   *  ver `chart-kit.tsx`. */
  downloadable?: boolean;
}) {
  return (
    <section className={`dashboard-panel ${className}`}>
      <header className="dashboard-panel-head">
        <div className="min-w-0">
          <h2 className="dashboard-panel-title">{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {downloadable ? <span className="dashboard-panel-actions">{action}<ChartDownload name={title}/></span> : action}
      </header>
      {children}
    </section>
  );
}
